// extracted by mini-css-extract-plugin
export default {"root":"CustomLandingPage_root__Kpmqw","main":"CustomLandingPage_main__E6kg9"};